<template>
  <span>
    {{ years }} {{ Number(years) === 1 ? 'Year' : 'Years' }}:
    <span :class="{ 'line-through': discounted }">${{ money(price.price, price.priceNoTax) }}</span>
    <span v-if="discounted" class="discounted-price">
      ${{ money(price.discounted_price) }} {{ price.discount_name }} {{ price.discount_rate }}%OFF
    </span>
    (${{ yearlyPrice }}/year)
  </span>
</template>

<script>
import { displayAmount } from '../../plugins/registration-gst';

export default {
  name: 'DomainRegistrationPrice',
  props: {
    price: { type: Object, required: true },
    years: { type: [Number, String], required: true },
    includeGst: { type: Boolean, default: true },
    showDiscount: { type: Boolean, default: true },
  },
  computed: {
    discounted() { return this.showDiscount && Number(this.price.discount) > 0; },
    yearlyPrice() {
      const amount = this.discounted
        ? this.money(this.price.discounted_price)
        : this.money(this.price.price, this.price.priceNoTax);
      return (Number(amount) / Number(this.years)).toFixed(2);
    },
  },
  methods: {
    money(amount, net = null) {
      return Number(displayAmount(amount, this.price, this.includeGst, net)).toFixed(2);
    },
  },
};
</script>
